import PropTypes from "prop-types";
import React, {
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
// import ImageResizer from "react-image-file-resizer";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import Webcam from "react-webcam";
import { Button } from "reactstrap";
import "./ReactCamera.scss";

const MESSS_STATUS_CAMREA = {
  NOT_SELECT_CAMERA: "Chưa chọn camera kết nối",
  NOT_FOUND_CAMERA_CAN_CONNECT: "Không có camera nào có thể kết nối",
  CURREN_CAMERA_DISCONNECT:
    "Camera đang chọn bị mất kết nối hoặc không có quyền sử dụng",
};

const ReactCamera = React.forwardRef((props, ref) => {
  const {
    handleCaptureImage,
    handleActiveCamera,
    handleOnFocusListSelectCamera,
    handleOnBlurListSelectCamera,
    isAllowCapture,
    inlinePreview = false,
    preferBackCameraOnMobile = false,
    preserveCaptureAspectRatio = false,
  } = props;
  const webcamRef = useRef(null);
  const { addToast } = useToasts();

  const [capturedImage, setCapturedImage] = useState(null);
  const [cameraError, setCameraError] = useState(false);
  const [showWebcam, setShowWebcam] = useState(false);
  const [showPreviewWebcam, setShowPreviewWebcam] = useState(false);
  //
  const [selectDevice, setSelectDevice] = useState(null);
  const [devices, setDevices] = useState([]);

  const isMobileDevice = /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(
    navigator.userAgent || ""
  );

  const pickDefaultDevice = useCallback(
    listDevice => {
      if (!Array.isArray(listDevice) || listDevice.length === 0) {
        return null;
      }

      if (!preferBackCameraOnMobile || !isMobileDevice) {
        return listDevice[0];
      }

      const backCameraByLabel = listDevice.find(device =>
        /(back|rear|environment|sau)/i.test(String(device?.label || ""))
      );

      if (backCameraByLabel) {
        return backCameraByLabel;
      }

      return listDevice[listDevice.length - 1];
    },
    [preferBackCameraOnMobile, isMobileDevice]
  );

  const handleDevices = useCallback(
    mediaDevices => {
      let listDevice = mediaDevices.filter(
        ({ kind, deviceId }) => kind === "videoinput" && deviceId
      );
      listDevice = listDevice.map((device, key) => {
        return {
          value: device.deviceId,
          label: device.label,
        };
      });
      if (listDevice.length > 0) {
        setSelectDevice(pickDefaultDevice(listDevice));
      } else {
        setTimeout(() => {
          setSelectDevice(null);
        });
        handleActiveCamera?.({
          isConnect: false,
          message: MESSS_STATUS_CAMREA.NOT_FOUND_CAMERA_CAN_CONNECT,
        });
        // Nếu chưa có thiết bị nào có thể sử dụng thì hỏi quyền hiện tại cho camera laptop
        handleAskActiveCamera();
      }
      setDevices(listDevice);
    },
    [setDevices, pickDefaultDevice]
  );
  //

  const dataURItoBlob = dataURI => {
    const byteString = atob(dataURI.split(",")[1]);
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  // const resizeImage = async imageSrc => {
  //   console.log(
  //     "🚀 ~ file: ReactCamera.js:71 ~ resizeImage ~ imageSrc:",
  //     imageSrc
  //   );
  //   try {
  //     const blob = dataURItoBlob(imageSrc);
  //     const resizedImageUri = await new Promise((resolve, reject) => {
  //       ImageResizer.imageFileResizer(
  //         blob,
  //         300, // Set the desired width
  //         300, // Set the desired height
  //         "JPEG", // Set the output format (e.g., JPEG, PNG)
  //         100, // Set the quality of the resized image (0 - 100)
  //         0, // Set the rotation angle (0 - 360)
  //         uri => {
  //           resolve(uri);
  //         },
  //         "base64" // Set the output type (base64, blob, file)
  //       );
  //     });
  //     const fileSizeInBytes = (resizedImageUri.length * 3) / 4;
  //     console.log("Resized Image Size:", fileSizeInBytes / 1024, "KB");
  //     return resizedImageUri;
  //     // Perform further processing or save the image
  //   } catch (error) {
  //     // Handle any errors that occurred during resizing
  //     console.error("Error resizing image:", error);
  //   }
  // };

  const resizeImage1 = async imageSrc => {
    try {
      return await new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        // Resize the canvas to the desired dimensions
        canvas.width = 800; // Set the desired width
        canvas.height = 600; // Set the desired height

        // Create an image element to load the captured image
        const capturedImage = new Image();

        // Load the captured image into the image element
        capturedImage.onload = () => {
          // Draw the captured image onto the canvas
          context.drawImage(capturedImage, 0, 0, canvas.width, canvas.height);

          // Export the canvas to a higher-quality image format
          const imageDataUrl = canvas.toDataURL("image/png", 1.0); // Use PNG format with maximum quality

          console.log(
            "Image Size:",
            (imageDataUrl.length * 3) / 4 / 1024,
            "KB"
          );
          resolve(imageDataUrl);
        };

        capturedImage.onerror = error => {
          reject(error);
        };

        capturedImage.src = imageSrc;
      });
    } catch (error) {
      // Handle any errors that occurred during resizing
      console.error("Error resizing image:", error);
      throw error;
    }
  };

  // Function to capture an image from the webcam
  const captureImage = async () => {
    if (!isAllowCapture) {
      return;
    }
    if (showWebcam && selectDevice) {
      if (webcamRef?.current?.stream?.active) {
        const videoEl = webcamRef.current.video;
        const screenshotDimensions =
          preserveCaptureAspectRatio && videoEl?.videoWidth && videoEl?.videoHeight
            ? { width: videoEl.videoWidth, height: videoEl.videoHeight }
            : undefined;
        const imageSrc = webcamRef.current.getScreenshot(screenshotDimensions);
        const finalImageSrc = preserveCaptureAspectRatio
          ? imageSrc
          : await resizeImage1(imageSrc);
        handleCaptureImage(finalImageSrc);
        setCapturedImage(finalImageSrc);
      } else {
        addToast("Không thể chụp hình", {
          appearance: "error",
          autoDismiss: true,
        });
        handleActiveCamera?.({
          isConnect: false,
          message: MESSS_STATUS_CAMREA.CURREN_CAMERA_DISCONNECT,
        });
        navigator.mediaDevices.enumerateDevices().then(handleDevices);
      }
    } else {
      // handleAskActiveCamera();
      addToast("Vui lòng chọn camera muốn kết nối để chụp", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  const handleUserMedia = stream => {
    console.log(
      "🚀 ~ file: ReactCamera.js:95 ~ handleUserMedia ~ stream:",
      stream
    );
    // Camera access granted
    // handleActiveCamera(true);
    // Additional logic or state updates if needed
  };

  const handleAskActiveCamera = async () => {
    try {
      setShowWebcam(false);
      // Request camera access
      await navigator.mediaDevices.getUserMedia({ video: true });
      await navigator.mediaDevices.enumerateDevices().then(handleDevices);
      setShowWebcam(true);
      // Access the webcam component and call the capture method
      const video = webcamRef.current.video;
      if (video) {
        video.play();
        // video.pause();
        video.load(); // Reload the video to start capturing again
      }
      setCameraError(false); // Reset the camera error state
    } catch (error) {
      // Handle error (e.g., user denied camera access)
      addToast("Camera access denied. Please change your setting", {
        appearance: "error",
        autoDismiss: true,
      });
      console.error("Camera không được cấp quyền", error);
      setCameraError(true); // Set the camera error state
    }
  };

  const styleTableSmall = {
    control: base => ({
      ...base,
      // height: !isMultiple ? 27.6 : undefined,
      minHeight: 27.6,
    }),
    input: base => ({
      ...base,
      minWidth: "200px",
      padding: 0,
      margin: 0,
    }),
    dropdownIndicator: base => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    clearIndicator: base => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    multiValue: base => ({
      ...base,
      // backgroundColor: 'red',
      borderRadius: 4,
      margin: "2px 2px 2px 0",
      padding: "2px 6px",
    }),
    multiValueLabel: base => ({
      ...base,
    }),
  };

  const ListDeviceCanUse = () => {
    return (
      <Select
        onFocus={() => {
          handleOnFocusListSelectCamera && handleOnFocusListSelectCamera();
        }}
        onBlur={() => {
          handleOnBlurListSelectCamera && handleOnBlurListSelectCamera();
        }}
        isClearable
        styles={styleTableSmall}
        placeholder={"Chọn thiết bị muốn kết nối"}
        options={devices}
        classNamePrefix="select2-selection form-sm"
        value={selectDevice}
        onChange={data => {
          setShowWebcam(false);
          setSelectDevice(data);
        }}
      />
    );
  };

  useImperativeHandle(ref, () => ({
    captureImage() {
      captureImage();
    },
  }));

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, [handleDevices]);

  useEffect(() => {
    if (selectDevice) {
      setShowWebcam(true);
      handleActiveCamera?.({
        isConnect: true,
        message: "",
      });
    } else {
      setShowWebcam(false);
      handleActiveCamera?.({
        isConnect: false,
        message:
          devices?.length > 0
            ? MESSS_STATUS_CAMREA.NOT_SELECT_CAMERA
            : MESSS_STATUS_CAMREA.NOT_FOUND_CAMERA_CAN_CONNECT,
      });
    }
  }, [selectDevice]);

  const isShowInlineWebcam =
    inlinePreview && showWebcam && !!selectDevice?.value;
    const isShowFloatingWebcam =
    !inlinePreview && showWebcam && !!selectDevice?.value;

  const webcamCommonProps = {
    onClick: element => {
      element.preventDefault();
    },
    key: selectDevice?.value,
    onUserMedia: handleUserMedia,
    videoConstraints: {
      deviceId: selectDevice?.value,
      ...(preserveCaptureAspectRatio
        ? {
            width: { ideal: 1920 },
            height: { ideal: 1080 },
          }
        : {}),
    },
    ref: webcamRef,
    ...(preserveCaptureAspectRatio ? { screenshotQuality: 0.95 } : {}),
  };

  return (
    <div
      className={`react-camera d-flex align-items-center gap-1${inlinePreview ? " react-camera--inline" : ""}`}
    >
      <div className="react-camera__toolbar d-flex align-items-center gap-1 flex-wrap">
        <ListDeviceCanUse></ListDeviceCanUse>
        <div className="action">
          <div onClick={captureImage}>
            <i
              className="bx bx-camera me-2 text-info icon-camera"
              title="Chụp hình"
              style={{
                cursor: isAllowCapture ? "pointer" : "not-allowed",
                fontSize: "24px",
                background: "white",
                border: "1px solid #556ee6",
                padding: "4px",
                borderRadius: "19px",
              }}
            ></i>
          </div>
          {!inlinePreview ? (
            <i
              className="bx bx-expand me-1 text-primary icon-expand"
              title="Preview"
              onClick={() => {
                if (!isAllowCapture) {
                  return;
                }
                setShowPreviewWebcam(true);
              }}
              style={{
                cursor: isAllowCapture ? "pointer" : "not-allowed",
                fontSize: "19px",
                background: "white",
                border: "1px solid #556ee6",
                padding: "4px",
                borderRadius: "19px",
              }}
            ></i>
          ) : null}
          <i
            onClick={() => {
              navigator.mediaDevices.enumerateDevices().then(handleDevices);
            }}
            className="bx bx-reset text-success icon-reset"
            title="Reload kết nối thiết bị"
            style={{
              cursor: "pointer",
              fontSize: "24px",
              background: "white",
            }}
          ></i>
        </div>
      </div>
      {isShowInlineWebcam ? (
        <div className="react-camera__preview react-camera__preview--inline w-100">
          <Webcam
            {...webcamCommonProps}
            screenshotFormat="image/jpeg"
            className="react-camera__preview-video"
          />
        </div>
      ) : null}
       {isShowFloatingWebcam ? (
        <div
          style={{
            visibility: showPreviewWebcam ? "visible" : "hidden",
          }}
        >
          {showPreviewWebcam ? (
            <div
              className="text-primary"
              style={{
                position: "fixed",
                top: "151px",
                right: "50%",
                transform: "translate(50%, -50%)",
                zIndex: 3,
                fontSize: "21px",
              }}
            >
              Preview camera
            </div>
          ) : null}
          <Webcam
            {...webcamCommonProps}
            screenshotFormat="image/jpeg"
            style={{
              position: "fixed",
              top: "408px",
              right: "50%",
              zIndex: 2,
              padding: "43px 24px",
              border: "1px solid #808080c2",
              borderRadius: "28px",
              background: "white",
              transform: " translate(50%, -50%)",
            }}
          />
          {showPreviewWebcam ? (
            <div
              className="text-danger"
              style={{
                position: "fixed",
                top: "668px",
                right: "50%",
                transform: "translate(50%, -50%)",
                zIndex: 3,
                fontSize: "21px",
              }}
            >
              <Button
                type="button"
                color="danger"
                className="me-2"
                onClick={() => {
                  setShowPreviewWebcam(false);
                }}
              >
                Đóng
              </Button>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
});

ReactCamera.propTypes = {
  // @ts-ignore
  handleCaptureImage: PropTypes.any,
  handleActiveCamera: PropTypes.any,
  handleOnFocusListSelectCamera: PropTypes.any,
  handleOnBlurListSelectCamera: PropTypes.any,
  isAllowCapture: PropTypes.bool,
  inlinePreview: PropTypes.bool,
  preferBackCameraOnMobile: PropTypes.bool,
  preserveCaptureAspectRatio: PropTypes.bool,
};

export default ReactCamera;
